<script lang="ts">
    import type {Icon} from "../@type";

    export let icon: Icon;
    export let name: string;
</script>
<img src={icon.url} alt={name} width="60" height="60" on:click>